import { flatMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { types, actions } from '@clearscore/redux.market';
import { actions as routesActions } from '@clearscore/redux.routes';
import { actions as profileActions, selectors as profileSelectors } from '@clearscore/redux.profile';
import { setEnvs } from '@clearscore/helpers.envs';
import { concat, of, EMPTY } from 'rxjs';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import { getSessionCookie } from '@clearscore/helpers.cookies';

const fetchMarketConfig = ({ payload }) => actions.fetchMarketConfig(payload.market);
const fetchStaticMarketConfig = (action) => {
    const market = resolveProp('requestMeta.market', action);
    return actions.fetchStaticMarketConfig(market);
};

const initialiseRoutes = ({ payload }, state) => {
    const { envs = {}, routes, market } = payload || {};
    setEnvs(envs);
    const { accountIDVStatus } = profileSelectors.getStatus(state);
    return routesActions.reinitialiseRoutes(routes, accountIDVStatus, market);
};

export default (action$, state$) =>
    action$.pipe(
        ofType(
            types.MARKET_FETCH_CONFIG_SUCCESS,
            types.MARKET_FETCH_STATIC_CONFIG_SUCCESS,
            types.MARKET_FETCH_CONFIG_ERROR,
            types.MARKET_SET_ACTIVE_MARKET,
        ),
        flatMap((action = {}) => {
            const marketConfigFetchStatus = resolveProp('market.fetchStatus', state$.value);
            switch (action.type) {
                case types.MARKET_FETCH_CONFIG_SUCCESS:
                case types.MARKET_FETCH_STATIC_CONFIG_SUCCESS:
                    return concat(
                        action.payload ? of(initialiseRoutes(action, state$.value)) : EMPTY,
                        getSessionCookie() ? of(profileActions.fetch()) : EMPTY,
                    );
                case types.MARKET_FETCH_CONFIG_ERROR:
                    return of(fetchStaticMarketConfig(action));
                case types.MARKET_SET_ACTIVE_MARKET:
                    if (marketConfigFetchStatus !== 'pending') {
                        return of(fetchMarketConfig(action));
                    }
                    return EMPTY;
                default:
                    return Promise.resolve();
            }
        }),
    );
